<template>
  <div>
    <div class="header">
      <p class="title">Selecione o tipo de ação da sua campanha</p>
      <a href="#" class="help">
        <i class="fal fa-external-link" />
        <p>Saiba mais</p>
      </a>
    </div>

    <div class="type-actions">
      <div
        class="item"
        :class="{
          inactive: campaign.type && campaign.type !== ACTION_TYPE.ARD,
        }"
        @click="setActionType(ACTION_TYPE.ARD)"
      >
        <div class="radio">
          <base-radio
            family="action-type"
            :option="ACTION_TYPE.ARD"
            v-model="campaign.type"
            :checked="campaign.type === ACTION_TYPE.ARD"
          />
        </div>

        <span class="icon">
          <i class="far fa-sync-alt" />
        </span>
        <p class="title">Ação de recorrência de data</p>

        <div class="description">
          <p>Ação disparada em todo dia específico do mês ou da semana</p>
        </div>
      </div>
      <div
        class="item"
        :class="{
          inactive: campaign.type && campaign.type !== ACTION_TYPE.ARC,
        }"
        @click="setActionType(ACTION_TYPE.ARC)"
      >
        <div class="radio">
          <base-radio
            family="action-type"
            :option="ACTION_TYPE.ARC"
            v-model="campaign.type"
            :checked="campaign.type === ACTION_TYPE.ARC"
          />
        </div>

        <span class="icon">
          <i class="fal fa-user-cog" />
        </span>
        <p class="title">Ação de recorrência de conversão</p>

        <div class="description">
          <p>
            Ação disparada quando o usuário se enquadra em alguma condição. (Ex:
            aniversários, feriados etc).
          </p>
        </div>
      </div>
      <div
        class="item"
        :class="{
          inactive: campaign.type && campaign.type !== ACTION_TYPE.APA,
        }"
        @click="setActionType(ACTION_TYPE.APA)"
      >
        <div class="radio">
          <base-radio
            family="action-type"
            :option="ACTION_TYPE.APA"
            v-model="campaign.type"
            :checked="campaign.type === ACTION_TYPE.APA"
          />
        </div>

        <span class="icon">
          <i class="fal fa-calendar-day" />
        </span>
        <p class="title">Ação pontual agendada</p>

        <div class="description">
          <p>Disparo único feito para apenas um usuário específico.</p>
        </div>
      </div>
      <div
        class="item"
        :class="{
          inactive: campaign.type && campaign.type !== ACTION_TYPE.API,
        }"
        @click="setActionType(ACTION_TYPE.API)"
      >
        <div class="radio">
          <base-radio
            family="action-type"
            :option="ACTION_TYPE.API"
            v-model="campaign.type"
            :checked="campaign.type === ACTION_TYPE.API"
          />
        </div>

        <span class="icon">
          <i class="fal fa-paper-plane" />
        </span>
        <p class="title">Ação pontual imediata</p>

        <div class="description">
          <p>Disparo de campanha enviado instantaneamente após criação.</p>
        </div>
      </div>
    </div>

    <div class="d-flex justify-end pt_20">
      <base-button
        :loading="loading"
        text="Continuar"
        @click="save(campaign)"
        :disabled="!campaign.type"
      />
    </div>
  </div>
</template>

<script>

import BaseButton from '@/components/Button';
import BaseRadio from '@/components/Radio';

const ACTION_TYPE = {
  ARD: 'ARD',
  ARC: 'ARC',
  APA: 'APA',
  API: 'API',
};
const components = {
  BaseButton,
  BaseRadio,
};

export default {
  components,
  props: {
    campaign: { type: Object, required: true },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      ACTION_TYPE,
    };
  },
  methods: {
    setActionType(type) {
        this.campaign.type = type;
    },
    save(campaign) {
      this.$emit('save', campaign);
    },
  },
};
</script>

<style scoped>
.tabs {
  margin-top: 25px;
  align-items: stretch;
  display: flex;
  flex-direction: column;
}

@media screen and (max-width: 991px) {
  .tabs {
    padding-bottom: 50px;
  }
}
.tab-container {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  overflow: hidden;
}
@media screen and (max-width: 991px) {
  .tab-container {
    display: block;
  }
}
.tab-container .tab-options {
  display: flex;
  flex-direction: column;
  width: 20%;
  min-width: 320px;
  position: relative;
  background: #3a3c40;
  padding: 5px 0;
  border-radius: 5px;
  font-weight: 500;
}
@media screen and (max-width: 991px) {
  .tab-container .tab-options {
    width: 100%;
  }
}
.tab-container .tab-options .tab {
  padding: 20px 35px;
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
  transition: all 0.1s ease;
  min-height: 100px;
}

.tab-container .tab-options .tab:not(.enabled) {
  cursor: not-allowed;
}

.tab-container .tab-options .tab .number {
  background: #46484d;
  border-radius: 50%;
  font-weight: bold;
  color: #aaaaab;
  font-size: 12px;
  margin-right: 17px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 15px;
}
@media screen and (max-width: 991px) {
  .tab-container .tab-options .tab {
    min-height: 80px;
    padding: 20px;
    transition: none;
  }
  .tab-container .tab-options .tab .number {
    width: 22px;
    height: 22px;
  }
  .tab-container .tab-options .tab .number.done {
    background: #288c79;
    color: #fff;
  }
}
.tab-container .tab-options .tab .name {
  font-size: 14px;
  line-height: 17px;
  color: #999;
  margin-bottom: 10px;
}
.tab-container .tab-options .tab p:not(.name) {
  color: #aaaaabd9;
  line-height: 15px;
  font-size: 12px;
}
.tab-container .tab-options .tab:not(.active).enabled:hover {
  background: #414347;
}
.tab-container .tab-content {
  width: 80%;
  padding: 25px;
  background: #3a3c40;
  overflow: auto;
  margin-left: 20px;
  border-radius: 5px;
  height: 100%;
}
@media screen and (max-width: 991px) {
  .tab-container .tab:after {
    content: '\f054';
    font-family: 'Font Awesome 5 Pro';
    position: absolute;
    right: 25px;
    font-size: 12px;
    color: #8c8c8c;
  }
  .tab-container .tab-content {
    width: 100%;
    margin: 0;
    position: relative;
    padding: 17px 20px;
  }
}
@media screen and (min-width: 992px) {
  .tab-container .tab.active {
    background: #4e3b47;
  }
  .tab-container .tab.active:before {
    content: '';
    height: 60px;
    width: 2px;
    position: absolute;
    left: 0;
    background: var(--default);
    top: 0;
    bottom: 0;
    margin: auto;
  }
  .tab-container .tab-options .tab:not(:last-child) {
    margin-bottom: 15px;
  }
  .tab-container .tab-options .tab.active .number {
    background: var(--default);
    color: #fff;
  }
  .tab-container .tab-options .tab.active .name {
    color: var(--default);
    font-weight: bold;
  }
  .tab-container .tab-options .tab.active p:not(.name) {
    font-weight: bold;
  }
  .header-mobile {
    display: none;
  }
  .coupons {
    max-height: 600px;
    overflow: auto;
    padding-right: 10px;
    margin-right: -10px;
  }
}
.tab-container .tab-options:before {
  content: '';
  height: 85%;
  width: 2px;
  position: absolute;
  left: 45px;
  background: #aaaaab33;
  top: 0;
  bottom: 0;
  margin: auto;
}
@media screen and (max-width: 991px) {
  .tab-container .tab-options .tab .name {
    color: var(--label-secondary);
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
  }
  .tab-container .tab-options .tab p:not(.name) {
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    color: #aaaaabf2;
  }
  .tab-container .tab-options:before {
    left: 30px;
  }
  .tab-container .tab-options.step-1:before {
    background: linear-gradient(to bottom, #288c79 0%, #aaaaab33 0%);
  }
  .tab-container .tab-options.step-2:before {
    background: linear-gradient(to bottom, #288c79 15%, #aaaaab33 15%);
  }
  .tab-container .tab-options.step-3:before {
    background: linear-gradient(to bottom, #288c79 15%, #aaaaab33 35%);
  }
  .tab-container .tab-options.step-4:before {
    background: linear-gradient(to bottom, #288c79 35%, #aaaaab33 60%);
  }
  .tab-container .tab-options.step-5:before {
    background: linear-gradient(to bottom, #288c79 60%, #aaaaab33 70%);
  }
  .tab-container .tab-options.step-6:before {
    background: linear-gradient(to bottom, #288c79 80%, #aaaaab33 90%);
  }
  .tab-container .tab-options.step-7:before {
    background: linear-gradient(to bottom, #288c79 90%, #aaaaab33 100%);
  }
}
.title {
  color: #aaaaab;
  line-height: 19px;
  font-size: 16px;
  font-weight: bold;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ffffff17;
  padding-bottom: 25px;
  position: relative;
}
.help {
  display: flex;
  align-items: center;
  padding-bottom: 3px;
  border-bottom: 1px solid transparent;
  text-decoration: none;
  color: var(--label-secondary);
  cursor: pointer;
}
.help:hover {
  border-color: var(--label-secondary);
  color: #e6e6e6;
}
.help i {
  font-size: 15px;
  margin-right: 10px;
}
.help p {
  font-size: 12px;
  line-height: 15px;
  font-weight: bold;
}
.type-actions {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-top: 25px;
}
.type-actions .item {
  background: var(--box-up);
  border-radius: 5px;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  cursor: pointer;
}
.type-actions .item.inactive {
  opacity: 0.45;
}
.type-actions .item .icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background: #4b4f54;
  margin-bottom: 10px;
}
.type-actions .item .icon i {
  color: var(--icon-inactive);
  font-size: 26px;
}
.type-actions .item p.title {
  color: var(--label-secondary);
  font-size: 14px;
  line-height: 17px;
}
.type-actions .item .description {
  color: #aaaaabf2;
  font-size: 12px;
  line-height: 20px;
  margin-top: 20px;
  padding: 20px 0;
  border-top: 1px solid #ffffff17;
  width: 100%;
  text-align: center;
}
.type-actions .item .radio {
  position: absolute;
  top: 20px;
  right: 10px;
}
.collapse .option {
  background: #45484d;
  border-radius: 5px;
  padding: 15px 20px;
  margin-bottom: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
}
.collapse .option:hover {
  background: #494c52;
}
.collapse .option .chevron {
  position: absolute;
  right: 10px;
  color: var(--icon-inactive);
}
.collapse .option .chevron i {
  transition: all 0.2s;
  font-size: 11px;
}
.collapse .option .chevron.active i {
  transform: rotate(180deg);
}
.collapse .option i {
  font-size: 15px;
  margin-right: 10px;
  color: var(--icon-inactive);
}
.collapse .option p {
  color: var(--label-primary);
  font-size: 12px;
  line-height: 15px;
}
.collapse .content {
  padding: 10px 0 5px 0;
}
.cost {
  background: #3a3c40;
  border: 1px solid #ffcc9914;
  border-radius: 12px;
  color: #d1802e;
  font-size: 14px;
  line-height: 17px;
  padding: 5px 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
}
.has.cost {
  background: #ffcc9914;
  border: 1px solid transparent;
}
.tags {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.tags .tag {
  color: var(--label-secondary);
  font-weight: bold;
  padding: 5px 10px;
  font-size: 10px;
  line-height: 12px;
  border-radius: 7px;
  border: 1px solid #ffffff17;
  margin-bottom: 5px;
  margin-right: 5px;
}
.coupons {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
}

.textarea-msg {
  position: relative;
}

.textarea .characters {
  position: absolute;
}

@media screen and (max-width: 991px) {
  .type-actions {
    grid-template-columns: repeat(1, 1fr);
  }
  .type-actions .item .description {
    padding-bottom: 0;
  }
  .coupons {
    grid-template-columns: repeat(1, 1fr);
  }
  .tabs-steps {
    color: #fff;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background: #2d2f32;
    position: fixed;
    bottom: 60px;
    padding: 5px;
    left: 0;
    right: 0;
  }
  .header {
    display: none;
  }
  .header-mobile {
    color: var(--default);
    font-size: 12px;
    line-height: 15px;
    padding-bottom: 15px;
    padding-top: 3px;
    margin-bottom: 20px;
    font-weight: bold;
    border-bottom: 1px solid #ffffff17;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    position: relative;
  }

  .tags .tag {
    color: #aaaaabf2;
    padding: 5px 10px;
    border-radius: 5px;
    border: 1px solid #505359;
    margin-bottom: 5px;
    margin-right: 5px;
  }

  .tabs-steps .tab {
    border-radius: 5px;
    padding: 10px;
    width: 100%;
    text-align: center;
  }

  .tabs-steps .tab.active {
    background: #45484d80;
  }

  .tabs-steps .tab p {
    color: var(--label-primary);
    font-size: 14px;
    line-height: 17px;
  }

  .tabs-steps .tab.active p {
    color: var(--label-secondary);
    font-weight: bold;
  }
  .progress-line,
  .progress-line > .done {
    position: absolute;
    width: 100%;
    height: 3px;
    left: 0;
    right: 0;
    top: 0;
  }
  .progress-line {
    background: #99999938;
  }
  .done {
    background: var(--default);
  }
  .help {
    padding-bottom: 0;
    border-bottom: none;
  }
  .cost {
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    padding: 5px 20px;
  }
}

.characters {
  position: absolute;
  bottom: 20px;
  right: 20px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  left: 0;
  padding: 0 20px;
}

.characters:before {
  position: absolute;
  left: 1px;
  top: -7.5px;
  content: '';
  background: #515159;
  width: calc(100% - 2px);
  height: 1px;
}

.characters .circle {
  position: relative;
  width: 30px;
  height: 30px;
}

.characters .circle svg {
  position: relative;
  width: 40px;
  height: 40px;
  transform: rotate(270deg);
}

.characters .circle svg circle {
  width: 30px;
  height: 30px;
  fill: none;
  stroke-width: 2;
  stroke: #000;
  transform: translate(5px, 5px);
  stroke-dasharray: 94;
  stroke-dashoffset: 94;
}
.characters .circle svg circle:nth-child(1) {
  stroke-dashoffset: 0;
  stroke: #515159;
}
.characters .circle svg circle:nth-child(2) {
  stroke: #ff3382;
}
.characters .circle .number {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  color: #aaaaab;
  font-weight: bold;
  transform: translate(5px, 5px);
}
.success-box {
  padding: 25px 20px 20px 20px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #344d4b;
}
.success-box i {
  color: #0dc59d;
  font-size: 45px;
}
.success-box p {
  color: #0dc59d;
  font-size: 14px;
  line-height: 17px;
  font-weight: bold;
  margin-top: 20px;
}
.custom-period {
  background: #45484d40;
  padding: 15px 15px 5px;
  margin-top: 20px;
}
.custom-period p {
  color: var(--label-primary);
  font-size: 12px;
  line-height: 15px;
  font-weight: bold;
  margin-bottom: 5px;
}
.address-box {
  display: flex;
  align-items: stretch;
  margin: 10px 0;
}
.address-box .address {
  background: #45484d99;
  padding: 15px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  width: 100%;
  color: #aaaaaaed;
}
.address-box .address p {
  font-size: 12px;
  line-height: 15px;
  margin-left: 10px;
  font-weight: 300;
}
.address-box .address i {
  font-size: 15px;
  color: var(--icon-inactive);
}
.shot-method-selected,
.shot-method-selected + span {
  color: var(--label-secondary);
  font-size: 12px;
  line-height: 15px;
}

.week {
  display: flex;
}

.day {
  font-size: 1.2em;
  width: 29px;
  height: 29px;
  color: var(--label-primary);
  border: 1px solid #8c8c8c;
  border-radius: 3px;
  margin-right: 10px;
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
}

.day.selected {
  color: white;
  border-color: var(--default);
  background: var(--default);
}
</style>
